import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Warehouse } from '../models/warehouse.model';
import { GLOBAL } from './global';
import { VariableService } from '../services/sharedVariables';

@Injectable()
export class WarehouseService{
   public url: string;
   public user_id:number;

   constructor(
     public _http: Http,
     public VariableService: VariableService
   )
   {
     this.url = GLOBAL.url;
     this.user_id = parseInt(this.VariableService.getCookie('user_id'));
   }

   getWarehouses()
   {
     return this._http.get(this.url+'warehouses/'+this.user_id).map(res => res.json());
   }

   getWarehouse()
   {
     return "getWarehouse from service";
   }

   addWarehouse(warehouse: Warehouse)
   {
     let json = JSON.stringify(warehouse);
     let params = 'json='+json;
     console.log(params);
     let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
     return this._http.post(this.url+'add-warehouse/'+this.user_id,params, {headers:headers}).map(res => res.json());

   }

   updateWarehouse(id:number,pWarehouse: Warehouse)
   {
     let json = JSON.stringify(pWarehouse);
     let params = "json="+json;
     let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
     console.log(params);
     return this._http.post(this.url+'edit-warehouse/'+id+'/'+this.user_id,params,{headers: headers})
                       .map(res => res.json());
   }

   deleteWarehouse(id:number)
   {
     return this._http.get(this.url+'delete-warehouse/'+id+'/'+this.user_id)
                     .map(res => res.json());
   }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/services/warehouse.service.ts